export class Cache<T> {
  private cache: Record<string, T>;

  constructor() {
    this.cache = {};
  }

  get(key: string, fn: () => T): T {
    if (!this.cache[key]) {
      this.cache[key] = fn();
    }

    return this.cache[key];
  }
}
